import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

let accordions = document.querySelectorAll(".c-accordion");
let accordionBoxs = document.querySelectorAll(".c-accordion__box");
let accordionIcons = document.querySelectorAll(".l-header__icon");

accordions.forEach((accordion, index) => {
  accordion.addEventListener("click", () => {
    const line = accordionIcons[index];
    const listBox = accordionBoxs[index];
    line.classList.toggle("is-active-icon");
    toggleAccordion(listBox);
  });
});

function toggleAccordion(listBox) {
  if (listBox.style.height === "0px" || listBox.style.height === "") {
    // 開く
    gsap.to(listBox, {
      height: "auto",
      duration: 0.5,
      opacity: 1,
      ease: "power2.inOut",
    });
  } else {
    // 閉じる
    gsap.to(listBox, {
      height: 0,
      duration: 0.5,
      opacity: 0,
      ease: "power2.inOut",
    });
  }
}
